<app-feature-hero
    variant="ims"
    title="IT Event Management"
    description="Get powered by AI to eliminate IT event noise with anytime, anywhere reporting feature"
    image=""
    imageAlt=""
></app-feature-hero>


<section class="container section-spacing">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">Get Clarity, Transparency & Insights Into Any Of Your IT Events</h2>
                <p class="section-paragraph">Infraon ITIM can monitor, consolidate, and analyze IT events so that you
                    can increase your IT infrastructure availability and performance. Stay clear of inconsequential
                    alert noise while identifying the source of IT service issues.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-img-right justify-content-center">
                <img src="/assets/img/feature-pages/infraon-ims/it-event/event-management-main-illustration.png" width="80%"
                    alt="Head office primary">
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Feature Highlights</h2>

    <div class="row mx-0 justify-content-center">
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/it-event/eye.svg" alt="Eye icon">
            </div>
            <p class="section-title-s">Unified Event Detection</p>
            <p class="section-paragraph-s">Harness a comprehensive event detection system that stays glued to IT event
                data in real-time. Use filtering & correlation features to enable quick access & get rid of IT noise.
            </p>
        </div>

        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/it-event/calander.svg"
                    alt="Calander icon 2">
            </div>
            <p class="section-title-s">Automated Event Management</p>
            <p class="section-paragraph-s">Accelerate the event management process by automating key tasks like logging,
                reporting & compliance adherence. Collaborate using workflows for quick AP-based data collection.</p>
        </div>
    </div>
    <div class="row mx-0 justify-content-center">
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/it-event/grid.svg" alt="Grid icon">
            </div>
            <p class="section-title-s">IT Event Dashboard</p>
            <p class="section-paragraph-s">Get a 360-degree view into your IT events & how they impact infrastructure
                performance – with a powerful & intuitive dashboard.</p>
        </div>

        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <div class="mb-3">
                <img class="d-block mx-auto" src="/assets/img/feature-pages/infraon-ims/it-event/like.svg" alt="Like icon">
            </div>
            <p class="section-title-s">Integrated Remediation Capabilities</p>
            <p class="section-paragraph-s">Define the frequency and scope of automated remediation with customizable
                role-based rules across multiple teams.</p>
        </div>
    </div>
</section>


<section class="bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 d-flex align-items-center position-relative bg-black-dots">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12 section-spacing">
                <h2 class="section-title">Other Features</h2>

                <div class="row mx-0 px-0">
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0"> Network Topology Report</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Network Discovery Report</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Automated Inventory Report</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0"> Automated Event Report</p>
                        </li>
                    </ul>
                    <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Network QoS Report</p>
                        </li>
                        <li class="d-flex align-items-center my-3"><img class="me-3"
                                src="/assets/img/feature-pages/infraon-assets/it-helpdesk/checkmark-circle.svg" alt="Checkmar icon">
                            <p class="section-paragraph mb-0">Network Fault & Incident Report</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 key-features-img-box d-flex justify-content-center position-absolute"
                style="right: 0;bottom: 0;">
                <img src="/assets/img/feature-pages/infraon-ims/api-monitoring/woman-1.webp" class="w-80" alt="woman point at features">
            </div>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>